import { Fab, FabProps } from '@material-ui/core'
import { Add } from '@material-ui/icons'
import React from 'react'
interface Props extends FabProps {
  onClick: (event: React.MouseEvent<HTMLButtonElement>) => void
  footer?: boolean
  floatTotalAmt?: boolean
  icon: React.ReactNode
}
export default function FloatButton(props) {
  const { onClick, footer, floatTotalAmt, icon, ...rest } = props
  return (
    <Fab
      {...rest}
      aria-label="add"
      style={{ bottom: floatTotalAmt ? `100px` : '' }}
      className={`float-btn ${footer ? 'with-footer' : ''}`}
      onClick={onClick}
    >
      {icon ? icon : <Add />}
    </Fab>
  )
}
